import { trackInteraction } from './analytics';
import { loadDrift, bindDriftEventHandlers } from './drift';
import { varsFromServer } from './client_side_injection_vars';

// List of drift supported langauges https://help.drift.com/article/custom-language/
// Passing an unsupported language will break drift.
const driftLanguages = [
  'en',
  'es',
  'de',
  'de-DE',
  'de-DE-formal',
  'hi',
  'hu',
  'et',
  'is',
  'nl',
  'pt',
  'pt-PT',
  'pt-BR',
  'sv',
  'zh',
  'fr',
  'it',
  'ru',
  'pl',
  'sl',
  'da',
  'fi',
  'hr',
  'ko',
  'nb',
  'ro',
  'sr',
  'th',
  'vi'
];

let didStartPlaybook = false;

export function handleClickChatUs() {
  document.getElementById('live-chat').addEventListener('click', () => {
    if (!window.drift) {
      initializeDrift();
    }

    global.drift.on('ready', api => {
      if (!didStartPlaybook) {
        global.drift.api.startInteraction({ interactionId: 84338 });
        didStartPlaybook = true;
      } else {
        api.sidebar.open();
      }
    });
  });
}

function initializeDrift() {
  loadDrift();

  // Set drift language based on locale, default to English
  const locale = varsFromServer.locale;
  const language = locale.split('-')[0];
  let driftLocale = 'en';
  if (driftLanguages.includes(locale)) {
    driftLocale = locale;
  } else if (driftLanguages.includes(language)) {
    driftLocale = language;
  }

  global.drift.config({ locale: driftLocale });

  global.drift.load(varsFromServer.driftChatKey);

  global.drift.debug(varsFromServer.driftDebug);

  bindDriftEventHandlers();
}

export function initNavTrackingListeners() {
  const navLinks = document.getElementsByClassName('track-nav-link-click');
  for (let i = 0; i < navLinks.length; i++) {
    const linkEl = navLinks[i];
    linkEl.addEventListener('click', () => {
      trackInteraction({ label: 'Nav - Main links', toPath: linkEl.pathname });
    });
  }

  const contactDropdown = document.getElementById('nav-cta-contact-us');
  contactDropdown.addEventListener('click', () => {
    trackInteraction({ label: 'Nav Contact Dropdown' });
  });
}
